import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { GetUserDetail, SystemGroup } from 'api/security';
import { useGlobalContext } from 'context/GlobalContext';

const transformEngineer = (user: GetUserDetail) => ({
  ...user,
  label: user?.fullName,
  id: user?.userId
});

const transformGroups = (groups: SystemGroup[]) =>
  groups?.map((group) => ({
    id: group?.id,
    label: group?.name,
    engineerOnly: group?.engineerOnly,
    engineers: group?.systemGroupUsers?.map(transformEngineer)
  }));

const useGetGroupsEngineersOnly = ({
  isEnabled,
  clientId,
  engineerOnly = true
}: {
  isEnabled?: boolean;
  clientId?: number | string;
  engineerOnly?: boolean;
}) => {
  const { security: securityApi } = useApiContext();
  const { showApiError } = useGlobalContext();
  const { t } = useTranslation('global');

  const params = {
    engineerOnly,
    clientId
  };

  const { data: groupsEngineersOnly, isLoading: isGroupsEngineersOnlyLoading } =
    useQuery(
      [KEYS.security.getSystemGroupByClientIdQuery(), params],
      () => securityApi.systemGroups.getSystemGroupByClientIdQuery(params),
      {
        refetchOnWindowFocus: false,
        enabled: isEnabled,
        select: ({ data }) => transformGroups(data?.data),
        onError: (error) => {
          showApiError(error, t('common.commonMessages.genericRequestError'));
        }
      }
    );

  return {
    groupsEngineersOnly,
    isGroupsEngineersOnlyLoading
  };
};

export default useGetGroupsEngineersOnly;
